//@ts-nocheck

'use client'

import React from 'react'

import Button from '../../../atoms/Button/Button.component'
import { Heading } from '../../../atoms/Typography/Typography.component'
import Accordion from '../../../molecules/Accordion/Accordion.component'
import { CtaTypes } from '../../../../types/Cta'

import * as S from '../Faq.styles'

interface FaqSimpleProps {
  title?: string
  cta?: CtaTypes
  faqs?: Array<{
    question: string
    answer: string
  }>
}

const FaqSimple: React.FC<FaqSimpleProps> = ({ title, cta, faqs }) => {
  return (
    <>
      <S.FaqSimpleHeader>
        {title ? <Heading typo="displayMD" content={title} fontPrimary /> : null}
        {cta ? <Button {...cta} variant="primary" iconEnd="arrow-right" /> : null}
      </S.FaqSimpleHeader>
      {(faqs && faqs.length > 0) ? <Accordion items={faqs} variant="twoColumns" withID /> : null}
    </>
  )
}

export default FaqSimple
